import React from 'react';
import * as styles from '../../styles/components/Timestamps.less';
import { withTranslation, WithTranslation } from 'react-i18next';

interface TimestampsOwnProps {
  createdAt: string | number | Date | null | undefined;
  updatedAt: string | number | Date | null | undefined;
}

// Reusable created/updated footer, shared by DashboardEditor and SelectedNode —
// both rendered an identically-styled block. Owns its own style and reads the
// shared `timestamps.*` i18n keys. Renders nothing for a missing timestamp (so
// an unsaved record shows no line rather than "Invalid Date").
const Timestamps = ({ createdAt, updatedAt, t }: TimestampsOwnProps & WithTranslation) => (
  <div className={styles['timestamps-container']}>
    {updatedAt &&
      <div>{t('timestamps.updatedAt') + ' ' + (new Date(updatedAt)).toLocaleDateString() + ' ' + t('timestamps.timeAt') + ' ' + (new Date(updatedAt)).toLocaleTimeString('default', { hour: '2-digit', minute: '2-digit' })}</div>}
    {createdAt &&
      <div>{t('timestamps.createdAt') + " " + (new Date(createdAt)).toLocaleDateString()} </div>}
  </div>
);

export default withTranslation('common')(Timestamps);
